/**
 * Small string utility class
 */

const KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;

const stringHelper = {
  // https://jsperf.com/capitalize-the-first-letter-of-string-in-javascript/4
  capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
  },
  titleize(str) {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  },
  /**
   * Convert dash-style string to camelCase
   * @param {String} dashStyleString
   */
  toCamelCase(dashStyleString) {
    // Transform string to lowercase and remove dash
    const nameArr = dashStyleString.toLowerCase().split('-');

    const firstElement = nameArr.shift();
    if (!firstElement) return null;

    // replace the rest of the word with its capitalized counterpart
    const otherElements = nameArr.map(stringHelper.capitalize);
    return firstElement + otherElements.join('');
  },

  /**
   * Convert camelCase string to snake case
   * @param {String} camelCaseString
   */
  toSnakeCase(camelCaseString) {
    return camelCaseString.replace(KEBAB_REGEX, (match) => '_' + match.toLowerCase());
  },

  /**
   * Trim excessive spaces (> 1) between characters
   * This function also make use of the default string trim function.
   * @param {string} str
   */
  trim(str) {
    return str.trim().replace(/[ ]{2,}/g, ' ');
  },

};

export default stringHelper;
